import { useAuth } from '../contexts/AuthContext';

export const usePermissions = () => {
  const { profile, isSuperAdmin, isTrainer, isClient } = useAuth();

  // Utilisateur restreint = tout utilisateur qui n'est pas super_admin
  // (trainer, client, etc.) - acces limite a leur organisation
  const isRestrictedUser = !isSuperAdmin;

  // Super admin can do everything
  const canEdit = (): boolean => {
    return isSuperAdmin;
  };

  // Check if user can access a specific organization
  const canAccessOrganization = (organizationId: string): boolean => {
    if (isSuperAdmin) return true;
    return profile?.organizationId === organizationId;
  };

  // Check if user can manage users
  const canManageUsers = (): boolean => {
    return isSuperAdmin;
  };

  // Check if user can manage organizations
  const canManageOrganizations = (): boolean => {
    return isSuperAdmin;
  };

  // Check if user can view all learners (super_admin) or just their org's learners
  const canViewAllLearners = (): boolean => {
    return isSuperAdmin;
  };

  // Check if user can create/edit training programs
  const canManagePrograms = (): boolean => {
    return isSuperAdmin;
  };

  // Get user's organization ID (for restricted users: trainers, clients)
  const getUserOrganizationId = (): string | null => {
    return profile?.organizationId || null;
  };

  return {
    canEdit,
    canAccessOrganization,
    canManageUsers,
    canManageOrganizations,
    canViewAllLearners,
    canManagePrograms,
    getUserOrganizationId,
    isSuperAdmin,
    isTrainer,
    isClient,
    isRestrictedUser
  };
};
